module.exports = __webpack_public_path__ + "media/images/common/kuchi_4-52ec35c3a0eb57deeebe8dbbd2acd167.gif";